module.exports = __webpack_public_path__ + "img/sfund.9822c281.svg";